import {
  AdminCreateRemoteConfig,
  AdminDeleteRemoteConfig,
  AdminFetchRemoteConfigs,
  AdminUpdateRemoteConfig,
} from 'src/constants/actionTypes'
import type { DeleteRemoteConfigPayload, RemoteConfig } from 'src/interfaces/remoteConfig'
import { Action } from 'src/utils/reduxUtils'
import type { RemoteConfigState } from './types'

const getInitialState = (): RemoteConfigState => {
  return {
    remoteConfigs: [],
    remoteConfigsLoading: false,
    saving: false,
    deletingId: null,
  }
}

// POST and PATCH answer with the key, so writes update the list without a refetch.
export const remoteConfigReducer = (
  state: RemoteConfigState = getInitialState(),
  action: Action<unknown>,
): RemoteConfigState => {
  switch (action.type) {
    case AdminFetchRemoteConfigs.type.REQUEST:
      return { ...state, remoteConfigsLoading: true }
    case AdminFetchRemoteConfigs.type.SUCCESS:
      return {
        ...state,
        remoteConfigs: (action.payload as RemoteConfig[] | undefined) ?? [],
        remoteConfigsLoading: false,
      }
    case AdminFetchRemoteConfigs.type.FAILED:
      return { ...state, remoteConfigsLoading: false }

    case AdminCreateRemoteConfig.type.REQUEST:
    case AdminUpdateRemoteConfig.type.REQUEST:
      return { ...state, saving: true }
    case AdminCreateRemoteConfig.type.SUCCESS:
      return {
        ...state,
        remoteConfigs: [...state.remoteConfigs, action.payload as RemoteConfig],
        saving: false,
      }
    case AdminUpdateRemoteConfig.type.SUCCESS: {
      const updated = action.payload as RemoteConfig

      return {
        ...state,
        remoteConfigs: state.remoteConfigs.map((remoteConfig) => {
          return remoteConfig.id === updated.id ? updated : remoteConfig
        }),
        saving: false,
      }
    }
    case AdminCreateRemoteConfig.type.FAILED:
    case AdminUpdateRemoteConfig.type.FAILED:
      return { ...state, saving: false }

    case AdminDeleteRemoteConfig.type.REQUEST:
      return {
        ...state,
        deletingId:
          (action.payload as DeleteRemoteConfigPayload | undefined)?.remoteConfigId ?? null,
      }
    case AdminDeleteRemoteConfig.type.SUCCESS:
      return {
        ...state,
        remoteConfigs: state.remoteConfigs.filter((remoteConfig) => {
          return remoteConfig.id !== action.payload
        }),
        deletingId: null,
      }
    case AdminDeleteRemoteConfig.type.FAILED:
      return { ...state, deletingId: null }

    default:
      return state
  }
}
